import { TokenManager } from "./token-manager"

export class HttpClient {
  private tokenManager: TokenManager

  constructor(tokenManager: TokenManager) {
    this.tokenManager = tokenManager
  }

  async fetch(url: string, options: RequestInit = {}, retry: boolean = true): Promise<Response> {
    const headers = new Headers(options.headers || {})
    const token = this.tokenManager.getToken()

    if (token) headers.set("Authorization", `Bearer ${token}`)

    const response = await fetch(url, { ...options, headers })

    if (response.status === 401 && retry) {
      const newToken = await this.tokenManager.refreshToken()
      if (newToken) return this.fetch(url, options, false)
    }

    return response
  }
}